<script setup>
  const props = defineProps({
    hasLabel: {
      default: false,
      type: Boolean
    },
    type: {
      default: 'text',
      type: String
    },
    name: {
      default: 'name',
      type: String
    },
    id: {
      default: '',
      type: String
    },
    class: {
      default: "",
      type: String
    },
    placeholder: {
      default: "",
      type: String
    },
    inputValue: {
      default: "",
      type: String
    }
  })
  defineEmits(['update:inputValue'])
</script>

<template>
  <!--  <label for="email" class="block">Email</label>-->
  <input
    :id="props.id ?? props.name"
    :type="props.type"
    :name="props.name"
    :class="props.class"
    class="shadow px-2 py-1 text-sm text-gray-400 rounded-md placeholder:text-xs placeholder-gray-300 w-full"
    :placeholder="props.placeholder ?? props.name"
    @input="$emit('update:inputValue', $event.target.value)"
  > 
</template>

<style scoped>

</style>
